import { v4 as uuid } from 'uuid';

import { startPollingMessages } from './startPollingMessages';
import { addTextMessageToChat } from '../../actions/sendMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { EChatbotPayload, fetchChatbotActionButtons } from '../../services/fetchChatbotActionButtons';
import { TThunkAction } from '../../types/redux/thunk';
import { setChatbotOnboardingButtons } from '../../actions/chatbot/actions';

export const getChatbotActionButtons =
  (payload: EChatbotPayload, message?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const messageId = uuid();

    if (message) {
      dispatch(addTextMessageToChat(message, CHATBOT_ID, messageId));
    }

    await fetchChatbotActionButtons(context, payload);

    if (payload !== EChatbotPayload.Initial) {
      dispatch(setChatbotOnboardingButtons([]));
      dispatch(
        startPollingMessages({
          isQuick: true,
          messageIdToDelete: message && messageId,
        }),
      );
    }
  };
